import { render, staticRenderFns } from "./discharge-medicine.vue?vue&type=template&id=5e13478f&scoped=true"
import script from "./discharge-medicine.vue?vue&type=script&lang=js"
export * from "./discharge-medicine.vue?vue&type=script&lang=js"
import style0 from "./discharge-medicine.vue?vue&type=style&index=0&id=5e13478f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e13478f",
  null
  
)

export default component.exports